/* eslint-disable @typescript-eslint/no-explicit-any */
export const mapTreeNode = (response: any, currentTree: any[], identifier: string): any[] => {
    const treeNode = mapTree(response);

    if (!currentTree?.length) return treeNode;
    const newNode = findItemById(treeNode, identifier);

    if (newNode) {
        newNode.isEmpty = !newNode?.children?.length;
    }

    const updatedTree = currentTree.map((node) => {
        if (node.id === identifier) {
            return newNode || node;
        }
        if (node.children && node.children.length > 0) {
            return {
                ...node,
                children: mapTreeNode(response, node.children, identifier)
            };
        }
        return node;
    });
    return updatedTree;
};

export const mapTree = (response: any) => {
    if (!response) return [];
    const individualId = response.individual?.id;
    if (!Array.isArray(response.product) || response.product?.length === 0) {
        return [
            {
                id: individualId,
                type: 'individual',
                children:
                    response.billingAccount?.map((ba: any) => ({
                        id: ba.id,
                        type: 'billingAccount',
                        children: []
                    })) || []
            }
        ];
    }
    const billingAccounts = response.billingAccount.map((ba: any) => {
        const baId = ba.id;
        const products = response.product.filter((p: any) => p.billingAccount?.id === baId);
        const bundles = products.filter((p: any) => p.isBundle);
        const nonBundles = products.filter((p: any) => !p.isBundle);
        const bundleNodes = bundles.map((bundle: any) => {
            const childProducts = nonBundles.filter((p: any) =>
                p.realizingService?.some((s: any) => s.name === 'BundleId' && s.id === bundle.id)
            );
            const accessIds: string[] = Array.from(
                new Set(
                    childProducts.flatMap(
                        (p: any) =>
                            p.realizingService?.filter((s: any) => s.name === 'AccessId').map((s: any) => s.id) || []
                    )
                )
            );
            const accessNodes = accessIds.map((accessId) => {
                const children = childProducts.filter((p: any) =>
                    p.realizingService?.some((s: any) => s.name === 'AccessId' && s.id === accessId)
                );
                const serviceIds = Array.from(
                    new Set(
                        children.flatMap(
                            (p: any) =>
                                p.realizingService?.filter((s: any) => s.name === 'ServiceId').map((s: any) => s.id) ||
                                []
                        )
                    )
                );
                return {
                    id: accessId,
                    type: 'access',
                    children: [
                        ...children.map((p: any) => ({
                            id: p.realizingService?.find((s: any) => s.name === 'ServiceId')?.id || p.name || '',
                            type: 'product',
                            productType: getProductType(p),
                            name: p.realizingService?.find((s: any) => s.name === 'ServiceId')?.id || p.name || ''
                        })),
                        ...serviceIds
                            .filter(
                                (serviceId) =>
                                    !children.some((p: any) =>
                                        p.realizingService?.some(
                                            (s: any) => s.name === 'ServiceId' && s.id === serviceId
                                        )
                                    )
                            )
                            .map((serviceId) => ({
                                id: serviceId,
                                type: 'service',
                                productType: 'SERVICE',
                                name: serviceId
                            }))
                    ]
                };
            });
            const bundleServiceIds = Array.from(
                new Set(
                    childProducts
                        .filter(
                            (p: any) =>
                                !p.realizingService?.some((s: any) => s.name === 'AccessId') &&
                                p.realizingService?.some((s: any) => s.name === 'ServiceId')
                        )
                        .flatMap(
                            (p: any) =>
                                p.realizingService?.filter((s: any) => s.name === 'ServiceId').map((s: any) => s.id) ||
                                []
                        )
                )
            );
            const bundleServiceNodes = bundleServiceIds.map((serviceId) => ({
                id: serviceId,
                type: 'service',
                productType: 'SERVICE',
                name: serviceId
            }));
            return {
                id: bundle.id,
                type: 'product',
                productType: getProductType(bundle),
                name: bundle.name,
                children: [...accessNodes, ...bundleServiceNodes]
            };
        });
        const nonBundleProducts = nonBundles.filter(
            (p: any) => !p.realizingService?.some((s: any) => s.name === 'BundleId')
        );
        const accessIds: string[] = Array.from(
            new Set(
                nonBundleProducts.flatMap(
                    (p: any) =>
                        p.realizingService?.filter((s: any) => s.name === 'AccessId').map((s: any) => s.id) || []
                )
            )
        );
        const accessNodes = accessIds.map((accessId) => {
            const children = nonBundleProducts.filter((p: any) =>
                p.realizingService?.some((s: any) => s.name === 'AccessId' && s.id === accessId)
            );
            const serviceIds = Array.from(
                new Set(
                    children.flatMap(
                        (p: any) =>
                            p.realizingService?.filter((s: any) => s.name === 'ServiceId').map((s: any) => s.id) || []
                    )
                )
            );
            return {
                id: accessId,
                type: 'access',
                children: [
                    ...children.map((p: any) => ({
                        id: p.realizingService?.find((s: any) => s.name === 'ServiceId')?.id || p.name || '',
                        type: 'product',
                        productType: getProductType(p),
                        name: p.realizingService?.find((s: any) => s.name === 'ServiceId')?.id || p.name || ''
                    })),
                    ...serviceIds
                        .filter(
                            (serviceId) =>
                                !children.some((p: any) =>
                                    p.realizingService?.some((s: any) => s.name === 'ServiceId' && s.id === serviceId)
                                )
                        )
                        .map((serviceId) => ({
                            id: serviceId,
                            type: 'service',
                            productType: 'SERVICE',
                            name: serviceId
                        }))
                ]
            };
        });
        const serviceIdNodes = nonBundleProducts
            .filter((p: any) => {
                const hasBundleId = p.realizingService?.some((s: any) => s.name === 'BundleId');
                const hasAccessId = p.realizingService?.some((s: any) => s.name === 'AccessId');
                const hasServiceId = p.realizingService?.some((s: any) => s.name === 'ServiceId');
                return !hasBundleId && !hasAccessId && hasServiceId;
            })
            .flatMap(
                (p: any) =>
                    p.realizingService
                        ?.filter((s: any) => s.name === 'ServiceId')
                        .map((s: any) => ({
                            id: s.id,
                            type: 'service',
                            productType: 'SERVICE',
                            name: s.id
                        })) || []
            );
        return {
            id: baId,
            type: 'billingAccount',
            children: [...bundleNodes, ...accessNodes, ...serviceIdNodes]
        };
    });
    return [
        {
            id: individualId,
            type: 'individual',
            children: billingAccounts
        }
    ];
};

const findItemById = (tree: any[], targetId: string): any | null => {
    for (const node of tree) {
        if (node.id === targetId) {
            return node;
        }
        if (node.children) {
            const found = findItemById(node.children, targetId);
            if (found) return found;
        }
    }
    return null;
};

const getProductType = (product: any): string => {
    const char = product.productCharacteristic || [];
    const typeEntry = char.find((c: any) => c.name === 'productType');
    return typeEntry?.value?.toUpperCase() || 'UNKNOWN';
};
